import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './file.scss';
import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import { FILE_STATUS } from '../constants';
var FileRubriq = function FileRubriq(_ref) {
  var disabled = _ref.disabled,
    file = _ref.file,
    removeFile = _ref.removeFile;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-100 mx-0",
    style: {
      border: '1px solid #E5E6E8',
      padding: '16px 20px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "clearfix position-relative pb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "file-name text-truncate mb-2"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-file-lines",
    className: "me-2"
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '1rem'
    },
    className: "fw-semibold"
  }, file.name), file.status !== FILE_STATUS.STATUS_UPLOAD_PROCESSING && /*#__PURE__*/React.createElement("div", {
    className: "float-end"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "".concat(t('remove'), " ").concat(file.name),
    className: "btn btn-link p-0 m-0 bg-transparent text-muted",
    disabled: disabled,
    onClick: removeFile,
    type: "button"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-trash"
  })))), file.status === FILE_STATUS.STATUS_UPLOAD_PROCESSING && /*#__PURE__*/React.createElement("div", {
    className: "text-secondary control-label text-transform-none ms-3"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "me-2",
    spin: true
  }), /*#__PURE__*/React.createElement(T, {
    source: "uploading"
  })), file.status === FILE_STATUS.STATUS_UPLOAD_SUCCESS && /*#__PURE__*/React.createElement("div", {
    className: "text-secondary control-label text-transform-none  ms-3"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-2",
    icon: "fa-solid fa-check"
  }), /*#__PURE__*/React.createElement(T, {
    source: "upload-complete"
  })), file.type === 'ithenticate' && FILE_STATUS.STATUS_FILETYPE_FAILURE && /*#__PURE__*/React.createElement("div", {
    className: "text-danger mt-2 ms-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: file.error
  })), file.type === 'digitalTranslation' && [FILE_STATUS.STATUS_FILETYPE_FAILURE, FILE_STATUS.STATUS_UPLOAD_FAILURE].includes(file.status) && /*#__PURE__*/React.createElement("div", {
    className: "text-danger mt-2 ms-3"
  }, file !== null && file !== void 0 && file.error ? /*#__PURE__*/React.createElement(T, {
    source: file.error
  }) : /*#__PURE__*/React.createElement(T, {
    source: "file-upload-error-try-again"
  })), file.type === 'digitalEdit' && [FILE_STATUS.STATUS_FILETYPE_FAILURE, FILE_STATUS.STATUS_UPLOAD_FAILURE].includes(file.status) && /*#__PURE__*/React.createElement("div", {
    className: "text-danger mt-2 ms-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "file-upload-error-try-again"
  })), file.type === 'digitalAbstract' && [FILE_STATUS.STATUS_FILETYPE_FAILURE, FILE_STATUS.STATUS_UPLOAD_FAILURE].includes(file.status) && /*#__PURE__*/React.createElement("div", {
    className: "text-danger mt-2 ms-3"
  }, file !== null && file !== void 0 && file.error ? /*#__PURE__*/React.createElement(T, {
    source: file.error
  }) : /*#__PURE__*/React.createElement(T, {
    source: "file-upload-error-try-again"
  }))));
};
export default FileRubriq;